/* eslint-disable react-hooks/exhaustive-deps */
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useRef, useState } from "react"
import { Button, Card, Col, Container, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Prompt, useHistory, useParams } from "react-router-dom"
import { AppDispatch } from "../../.."
import AlertComponent from "../../../components/AlertComponent"
import { showInfoToast } from "../../../components/CustomToast"
import TextInput from "../../../components/InputWrapper/TextInput"
import DateInput from "../../../components/InputWrapper/DateInput"
import NumberInput from "../../../components/InputWrapper/NumberInput"
import TextAreaInput from "../../../components/InputWrapper/TextAreaInput"
import MasterRegisterFormRow from "../../../components/MasterRegisterFormRow"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import CONSTANT from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import BihinzaikoService from "../../../service/purchase/bihinzaiko/bihinzaikoService"
import ZyomuinSearchModal from "../../../components/SearchModal/ZyomuinSearchModal"
import { TApiResponse } from "../../../service/TApiResponse"
import { RootState } from "../../../globalStore/rootreducer"
import Decimal from "decimal.js"
import BusyoService from "../../../service/master/busyo/busyoService"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { T部所マスタ } from "../../../components/ComboBox/BusyoComboBox"
import ComboBox from "../../../components/ComboBox"
import stringUtil from "../../../ts/util/stringUtil"
import { TBihinzaikoHaraidasiRegisterPostReq } from "../../../service/purchase/bihinzaiko/TBihinzaiko"
import * as wjrInput from "@grapecity/wijmo.react.input"
import * as wjcInput from "@grapecity/wijmo.input"

const PurchaseBihinzaikoRegister = () => {
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const disPatch: AppDispatch = useDispatch()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // 戻る確認ダイアログ表示フラグ
  const isPrompt = useRef(false)

  //#region [state]

  // 表示項目のstate
  const [受払日, set受払日] = useState<string | null>(eigyobi)
  const [乗務員コード, set乗務員コード] = useState<string>()
  const [乗務員名, set乗務員名] = useState<string>()
  const [部所コード, set部所コード] = useState<string | null>("")

  const [備品コード, set備品コード] = useState<string>()
  const [備品名, set備品名] = useState<string>()
  const [サイズ, setサイズ] = useState<string>()
  const [, set単位] = useState<string>()
  const [ロット, setロット] = useState<string>()
  const [払出単価, set払出単価] = useState<number>()
  const [在庫数量, set在庫数量] = useState<number>(0)
  const [払出数量, set払出数量] = useState<number>(0)
  const [払出金額, set払出金額] = useState<number>(0)
  const [在庫場所, set在庫場所] = useState<string>()
  const [備考, set備考] = useState<string>("")
  const [更新日時, set更新日時] = useState<string>("")

  // 部所
  const [部所ComboBox, set部所ComboBox] = useState<TWijmoComboBox<
    string,
    T部所マスタ
  > | null>(null)
  const [部所IsLoadEnded, set部所IsLoadEnded] = useState<boolean>(false)
  const [部所ItemSource, set部所ItemSource] = useState<T部所マスタ[]>()

  // errorフラグ
  const [hasSearched, setHasSearched] = useState(false)
  const [Form外エラーメッセージList] = useState<string[]>([])

  // modal
  const [isConfirmModalShow, setIsConfirmModalShow] = useState(false)
  // 乗務員検索
  const [is乗務員検索Modal, setIs乗務員検索Modal] = useState(false)

  //#endregion

  //#region [method]
  /**
   * データ取得
   */
  const getData = async (id: string) => {
    const service = new BihinzaikoService()

    try {
      const res = await service.get(id)
      if (res.data) {
        set備品コード(res.data.備品コード)
        set備品名(res.data.備品名)
        setサイズ(res.data.サイズ)
        set単位(res.data.単位)
        setロット(res.data.ロット)
        set払出単価(res.data.払出単価)
        set在庫数量(res.data.在庫数量)
        set在庫場所(res.data.在庫場所)
        // 払出ごとの備考とするため受の備考は使わない
        // set備考(res.data.備考)
        set備考("")
        set更新日時(res.data.更新日時)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    }
  }

  /**
   * 送信前バリデーションチェックなど
   */
  const beforeSubmit = () => {
    if (!isValidationCheck()) return
    setIsConfirmModalShow(true)
  }

  /**
   * 登録時チェック
   * @returns
   */
  const isValidationCheck = () => {
    disPatch(clearAlert())
    Form外エラーメッセージList.splice(0, Form外エラーメッセージList.length)

    let hasError = false
    let messages: Array<string> = []

    // 数量の相関チェック と 必須/マイナスチェックの組み合わせ
    const n在庫数量 = new Decimal(在庫数量 ?? 0)
    const n払出数量 = new Decimal(払出数量 ?? 0)
    if (n在庫数量.minus(n払出数量).toNumber() < 0) {
      // 在庫数との相関チェック
      messages.push(`払出数量は、在庫数量を越えない値を入力してください。`)
      hasError = true
    }

    // 払出数量0チェック
    if (n払出数量.toNumber() === 0) {
      messages.push(`払出数量は、0以外の値を入力してください。`)
      hasError = true
    }

    // 必須チェック
    if (stringUtil.isNullOrWhiteSpace(部所コード)) {
      messages.push(`部所を入力してください。`)
      hasError = true
    }
    if (受払日 == null) {
      // isRequired=trueなので本来あり得ないError
      messages.push(`受払日を入力してください。`)
      hasError = true
    }

    if (hasError) {
      Form外エラーメッセージList.push(...messages)
      setHasSearched(hasError)
    }

    return !hasError
  }

  /**
   * 送信
   */
  const submit = async () => {
    try {
      // バリデーション完了後のため数値は正常だが エラー回避のためここでも確認
      if (受払日 == null || 部所コード == null || 払出数量 == null) return

      let data: TBihinzaikoHaraidasiRegisterPostReq = {
        受払日,
        部所コード,
        乗務員コード: 乗務員コード ?? "",
        払出数量,
        備考,
        更新日時,
      }
      const service = new BihinzaikoService()

      let res: TApiResponse<boolean>

      res = await service.putHaraidasi(id, data)

      disPatch(setAlerts(res))
      if (res) {
        isPrompt.current = false
        history.goBack()
        showInfoToast(`備品在庫払出の更新が完了しました`)
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmModalShow(false)
    }
  }

  //#endregion

  //#region [effect]

  //初期設定
  useEffect(() => {
    //画面全体ロック
    disPatch(画面ロック開始())

    Promise.all([new BusyoService().getList({})]).then(([部所ListRes]) => {
      set部所ItemSource(部所ListRes.data)

      // id存在時はデータを取得し更新
      getData(id).finally(() => {
        disPatch(画面ロック解除())
      })
      // ファイルロード後、戻るボタン押下時に警告が出るように変更
      isPrompt.current = true
    })
  }, [])

  // error監視
  useEffect(() => {
    if (hasSearched && [...Form外エラーメッセージList].find((e) => e !== "")) {
      disPatch(setWarningAlerts([...Form外エラーメッセージList]))
    }
    setHasSearched(false)
  }, [hasSearched])

  // 払出金額の算出
  useEffect(() => {
    const d払出単価 = new Decimal(払出単価 ?? 0)
    const d払出数量 = new Decimal(払出数量 ?? 0)

    set払出金額(d払出単価.times(d払出数量).toNumber())
  }, [払出数量])

  //#endregion

  return (
    <>
      <Prompt
        when={isPrompt.current}
        message={CONSTANT.MESSAGES.BROWSER_BACK}></Prompt>
      <Container fluid>
        {/* 画面タイトル */}
        <Row className="page-title-row">
          <Col className="page-title-col">
            <span className="page-title">備品在庫払出</span>
          </Col>
        </Row>
        {/* アラート表示 */}
        <Row>
          <Col>
            <AlertComponent />
          </Col>
        </Row>
        <Row>
          <Col>
            {/* 検索条件カード */}
            <Card className="w-70rem">
              <Card.Body>
                <Container fluid className="register-form">
                  {/* 受払日 */}
                  <MasterRegisterFormRow label="受払日" isRequired={true}>
                    <div className="w-10rem">
                      <DateInput
                        autoFocus={true}
                        id="受払日"
                        value={受払日}
                        setValue={(v) => {
                          set受払日(v!)
                        }}
                        placeholder="受払日"
                        isRequired={true}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  <MasterRegisterFormRow label="部所" isRequired={true}>
                    <div className="w-100rem">
                      <ComboBox.Busyo
                        itemsSource={部所ItemSource}
                        isLoadEnded={部所IsLoadEnded}
                        setIsLoadEnded={set部所IsLoadEnded}
                        isReadOnly={
                          !stringUtil.isNullOrWhiteSpace(乗務員コード)
                        }
                        isRequired={true}
                        isEmpty={true}
                        selectedValue={部所コード}
                        setSelectedValue={set部所コード}
                        ComboBox={部所ComboBox}
                        setComboBox={set部所ComboBox}></ComboBox.Busyo>
                    </div>
                  </MasterRegisterFormRow>
                  <MasterRegisterFormRow label="乗務員">
                    {/* 乗務員コード */}
                    <div className="w-15rem">
                      <TextInput
                        id="乗務員コード"
                        name="乗務員コード"
                        value={乗務員コード}
                        setValue={set乗務員コード}
                        placeholder="乗務員"
                        isRequired={true}
                        isReadOnly={true}
                      />
                    </div>
                    {/* 乗務員検索モーダル */}
                    <button
                      type="button"
                      className="icon-button"
                      onClick={(e) => {
                        e.preventDefault()
                        setIs乗務員検索Modal(true)
                      }}>
                      <FontAwesomeIcon
                        className="icon-button-inner"
                        icon={faSearch}></FontAwesomeIcon>
                    </button>
                    {/* 乗務員名 */}
                    <div className="w-50rem d-flex">
                      <TextInput
                        id="乗務員名"
                        name="乗務員名"
                        value={乗務員名}
                        setValue={set乗務員名}
                        isReadOnly={true}
                        placeholder="乗務員名"
                      />
                      <Button
                        className="btn btn-primary move-edit-page"
                        onClick={() => {
                          // 乗務員情報をclearする。
                          set乗務員コード("")
                          set乗務員名("")
                          set部所コード("")
                        }}>
                        クリア
                      </Button>
                    </div>
                  </MasterRegisterFormRow>
                  {/* 備品コード */}
                  <MasterRegisterFormRow label="備品コード">
                    <div className="w-15rem">
                      <TextInput
                        id="備品コード"
                        name="備品コード"
                        value={備品コード}
                        setValue={set備品コード}
                        isReadOnly={true}
                        maxLength={15}
                        placeholder="備品コード"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 備品名 */}
                  <MasterRegisterFormRow label="備品名">
                    <div className="w-100rem">
                      <TextInput
                        id="備品名"
                        name="備品名"
                        value={備品名}
                        setValue={set備品名}
                        isReadOnly={true}
                        placeholder="備品名"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* サイズ */}
                  <MasterRegisterFormRow label="サイズ">
                    <div className="w-15rem">
                      <TextInput
                        id="サイズ"
                        name="サイズ"
                        value={サイズ}
                        setValue={setサイズ}
                        isReadOnly={true}
                        placeholder="サイズ"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* ロット */}
                  <MasterRegisterFormRow label="ロット">
                    <div className="w-15rem">
                      <TextInput
                        id="ロット"
                        name="ロット"
                        value={ロット}
                        setValue={setロット}
                        isReadOnly={true}
                        placeholder="ロット"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 払出単価 */}
                  <MasterRegisterFormRow label="払出単価">
                    <div className="w-15rem wj-align-right">
                      <NumberInput
                        id="払出単価"
                        name="払出単価"
                        value={払出単価}
                        setValue={set払出単価}
                        readOnly={true}
                        placeholder="払出単価"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 在庫数量 */}
                  <MasterRegisterFormRow label="在庫数量">
                    <div className="w-15rem">
                      <NumberInput
                        id="在庫数量"
                        name="在庫数量"
                        value={在庫数量}
                        setValue={set在庫数量}
                        readOnly={true}
                        placeholder="在庫数量"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 払出数量 */}
                  <MasterRegisterFormRow
                    label="払出数量"
                    isRequired={true}
                    remarks="-9999～9999">
                    <div className="w-15rem">
                      <wjrInput.InputNumber
                        id="払出数量"
                        name="払出数量"
                        isRequired={true}
                        value={払出数量}
                        min={-9999}
                        max={9999}
                        setValue={set払出数量}
                        placeholder="払出数量"
                        format={"g0"}
                        valueChanged={(c: wjcInput.InputNumber, e: any) => {
                          c.value != null
                            ? set払出数量(c.value)
                            : set払出数量(0)
                        }}
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 払出金額 */}
                  <MasterRegisterFormRow label="払出金額">
                    <div className="w-15rem">
                      <NumberInput
                        id="払出金額"
                        name="払出金額"
                        value={払出金額}
                        setValue={set払出金額}
                        readOnly={true}
                        placeholder="払出金額"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 在庫場所 */}
                  <MasterRegisterFormRow label="在庫場所">
                    <div className="w-100rem">
                      <TextInput
                        id="在庫場所"
                        name="在庫場所"
                        value={在庫場所}
                        setValue={set在庫場所}
                        isReadOnly={true}
                        placeholder="在庫場所"
                      />
                    </div>
                  </MasterRegisterFormRow>
                  {/* 備考 */}
                  <MasterRegisterFormRow label="備考">
                    <div className="w-100rem">
                      <TextAreaInput
                        id="備考"
                        name="備考"
                        value={備考}
                        setValue={set備考}
                        placeholder="備考"
                      />
                    </div>
                  </MasterRegisterFormRow>
                </Container>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className="search-button w-95rem">
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              variant="waiting"
              data-num="0"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                beforeSubmit()
              }}>
              {`更新`}
            </Button>
          </Col>
          <Col>
            <Button
              type="button"
              variant="secondary"
              onClick={() => history.goBack()}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
      {/* 乗務員検索 */}
      <ZyomuinSearchModal
        isShow={is乗務員検索Modal}
        setIsShow={setIs乗務員検索Modal}
        busyoCode={部所コード ?? ""}
        setZyomuin={(乗務員) => {
          set乗務員コード(乗務員.社員コード)
          set乗務員名(乗務員.社員氏名)
          set部所コード(乗務員.部所コード)
        }}></ZyomuinSearchModal>
      <ConfirmModal
        isShow={isConfirmModalShow}
        hideHandler={setIsConfirmModalShow}
        submitHandler={submit}>
        入力された内容で更新しますか？
      </ConfirmModal>
    </>
  )
}

export default PurchaseBihinzaikoRegister
